import React from 'react';
import PureComponent from '../../pure';

// import InputText from "../formElements/InputText";

import sAction from 'sAction';

import assembleURLHash from '../../../action/Base/route/assembleURLHash';

export default class ChangesDetectedPopup extends PureComponent {
    constructor(props) {
        super(props);
    }

    // ulozeni zmen v popupu
    usePopup = (e) => {
        sAction.popupHide();

        const uId = sAction.dataGet('conf/user/id');
        const listModule = sAction.dataGet('view/modul');

        const changes = sAction.getStorage('changes-'+listModule+'-'+uId);

        // sAction.redirect("http://localhost:8080/#detail/"+changes.module+"/"+changes.id+"")
        if (changes.id == null) {
            changes.id = '';
        }
        sAction.href(assembleURLHash('detail', changes.module, changes.id), '_blank');
    };

    render() {
        const id = this.props.data.get('id');

        return (
            <div>
                <div className="acmPopupHeader">
                    {sAction.translate('LBL_POPUP_CHANGES_HEADER')}
                </div>
                <div className="acmPopupContent">
                    <div className="w100">
                        <p> {sAction.translate('LBL_POPUP_TEXT')}</p>
                    </div>
                </div>
                <div className="acmPopupButtons">
                    <button className="acmButton hoverGreen" data-value={id} onClick={this.usePopup}>{sAction.translate('LBL_POPUP_LOAD')}</button>
                    <button className="acmButton hoverRed" data-value={id} onClick={() => sAction.deleteChangesPopup(this.props.data.get('module'))}>{sAction.translate('LBL_POPUP_DISCARD')}</button>
                </div>
            </div>
        );
    }
}
